import React, { useState } from 'react';
import './Dashboard.css';
import Layout from '../../../components/Layout';
import AdminNavbar from '../../../components/Admin/AdminNavbar/AdminNavbar';
import { Box, Typography, Tabs, Tab, FormControl, Select, MenuItem } from '@mui/material';
import UserTeacherAnalytics from '../../../components/Admin/Dashboard/UserTeacherAnalytics/UserTeacherAnalytics';
import SessionAnalytics from '../../../components/Admin/Dashboard/SessionAnalytics/SessionAnalytics';
import RevenueAnalytics from '../../../components/Admin/Dashboard/RevenueAnalytics/RevenueAnalytics';

const Dashboard = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [timePeriod, setTimePeriod] = useState('last_month');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleTimePeriodChange = event => {
    setTimePeriod(event.target.value);
  };

  return (
    <Layout title="Klass Online | Dashboard">
      <Box className="dashboard-container-main">
        <Box className="navbar-fixed">
          <AdminNavbar />
        </Box>
        <Box className="dashboard-container">
          <Box className="dashboard-content">
            <Typography className="dashboard-title">Dashboard</Typography>
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}
            >
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="User" />
                <Tab label="Session" />
                <Tab label="Revenue" />
              </Tabs>
              <FormControl size="small" className="time-period-dropdown-container">
                <Select
                  value={timePeriod}
                  onChange={handleTimePeriodChange}
                  className="time-period-dropdown"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        '& .MuiMenuItem-root': {
                          fontSize: '14px',
                          fontFamily: 'Poppins',
                        },
                      },
                    },
                  }}
                  sx={{
                    minWidth: '150px',
                    height: '36px',
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '14px',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderRadius: '20px',
                    },
                    '& .MuiSelect-select': {
                      padding: '8px 14px',
                    },
                  }}
                >
                  <MenuItem value="last_day">Last 24 Hours</MenuItem>
                  <MenuItem value="last_week">Last 7 Days</MenuItem>
                  <MenuItem value="last_2_weeks">Last 2 Weeks</MenuItem>
                  <MenuItem value="last_month">Last 30 Days</MenuItem>
                  <MenuItem value="last_3_months">Last 3 Months</MenuItem>
                  <MenuItem value="last_6_months">Last 6 Months</MenuItem>
                  <MenuItem value="last_year">Last Year</MenuItem>
                </Select>
              </FormControl>
            </Box>
            {selectedTab === 0 && <UserTeacherAnalytics timePeriod={timePeriod} />}
            {selectedTab === 1 && <SessionAnalytics timePeriod={timePeriod} />}
            {selectedTab === 2 && <RevenueAnalytics timePeriod={timePeriod} />}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Dashboard;
